exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Project Colors\n */\n/**\n  Contact page scss\n */\n.jumbotron {\n  background-color: #222222; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/contact/contact.component.scss
// module id = 383
// module chunks = 1